module.exports = __webpack_public_path__ + "img/s1_img2.2bdafeb0.png";